/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import {
  compose, withState, withHandlers, lifecycle,
} from 'recompose'
import Typography from '@mui/material/Typography'
import { useOutletContext } from 'react-router-dom'
import OccupationsForm from '../../Forms/OccupationsForm'
import Footer from './Footer'
import {
  fetchPublishedOccupations,
  fetchPublicAndPublishedOccupations,
  setListingOccupations,
  fetchListingOccupations,
} from '../../../../../redux/actions'
import {
  selectPublishedOccupations,
  selectPublishedOccupationsHierarchy,
  selectPublicAndPublishedOccupations,
  selectPublicAndPublishedOccupationsHierarchy,
  selectListing,
  hasPolicy,
} from '../../../../../redux/selectors'
import { ACCESS_PRIVATE_AFFILIATIONS } from '../../../../../auth/policies'
import Processing from './Processing'

function OccupationsSection() {
  const dispatch = useDispatch()
  const { verificationListing } = useOutletContext()

  if (!verificationListing || !verificationListing.id) {
    return null
  }

  const [processing, setProcessing] = useState(true)
  const [selectedOccupationMappings, setSelectedOccupationMappings] = useState(null)

  const publishedOccupationsHierarchy = useSelector(selectPublishedOccupationsHierarchy)
  const publishedOccupations = useSelector(selectPublishedOccupations)
  const publicAndPublishedOccupationsHierarchy = useSelector(selectPublicAndPublishedOccupationsHierarchy)
  const publicAndPublishedOccupations = useSelector(selectPublicAndPublishedOccupations)
  const canAccessPrivateAffiliations = useSelector(hasPolicy(ACCESS_PRIVATE_AFFILIATIONS))

  const getPublishedOccupations = () => {
    setProcessing(true)
    return dispatch(fetchPublishedOccupations()).then((x) => setProcessing(false))
  }
  const getPublicAndPublishedOccupations = () => {
    setProcessing(true)
    return dispatch(fetchPublicAndPublishedOccupations()).then((x) => setProcessing(false))
  }

  const getListingsOccupations = () => {
    setProcessing(true)
    return dispatch(fetchListingOccupations(verificationListing?.id)).then((x) => setSelectedOccupationMappings(x))
  }
  const setListingOccupationsFn = (listingId) => {
    setProcessing(true)
    return dispatch(setListingOccupations(listingId, selectedOccupationMappings)).then((x) => {
      setSelectedOccupationMappings(x)
      setProcessing(false)
    })
  }

  const onSaveOccupations = () => {
    setListingOccupationsFn(verificationListing?.id)
  }

  useEffect(() => {
    getPublishedOccupations()
    getPublicAndPublishedOccupations()
    getListingsOccupations()
  }, [])

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
      }}
    >
      <Typography>
        De-selecting an entire group will also mark any subordinate affiliations ineligible for the listing. For
        example, if you de-select "Military", all branches will be marked ineligible.
      </Typography>
      <Typography>
        If you only want to mark specific affiliations ineligible, simply drill into the group and uncheck the ones
        that don''t apply. For example, drilling into "Military" and de-selecting "Army" means that all other
        branches will still be eligible for the listing.
      </Typography>
      <OccupationsForm
        publishedOccupationsHierarchy={publishedOccupationsHierarchy}
        publishedOccupations={publishedOccupations}
        publicAndPublishedOccupationsHierarchy={publicAndPublishedOccupationsHierarchy}
        publicAndPublishedOccupations={publicAndPublishedOccupations}
        canAccessPrivateAffiliations={canAccessPrivateAffiliations}
        selectedOccupationMappings={selectedOccupationMappings}
        setSelectedOccupationMappings={setSelectedOccupationMappings}
      />
      <Footer label="Save" processing={processing} onSubmit={onSaveOccupations} />
      {processing ? <Processing /> : null}
    </div>
  )
}

export default OccupationsSection
